module.exports = __webpack_public_path__ + "static/media/Assets-05-MNM-halftone.16496dd2.png";